import type {
  RecommendedArticle,
  RecommendedModel as GeneratedRecommendedModel,
  RecommendedProduct,
} from '../../../generated/frontend'

export type RecommendedContentType = RecommendedArticle | Partial<RecommendedProduct>

export type RecommendedModel = Omit<GeneratedRecommendedModel, 'content'> & {
  content: RecommendedContentType[]
}

export type RecommendationsType = {
  models: RecommendedModel[]
}

export enum Model {
  CF_PAGE_LEVEL = 'segment/content_recommendation_cf_page_level',
  CF_PRODUCT_CATEGORY_LEVEL = 'segment/content_recommendation_collaborative_filtering',
  MIXED_ADVICE = 'segment/mixed/adviceOnly',
  RECENT_CATEGORY = 'segment/most_recent_category',
  VECTOR_RECOMMENDATION = 'merlin/vector_recommendations',
}

const getModel = (models: RecommendedModel[], modelName: Model): RecommendedModel | null => {
  const model = models.find((model) => model.model == modelName)
  const hasRecommendations = model?.content && model.content.length > 0

  return hasRecommendations ? model : null
}

export type ModelsDataType = Record<Model, RecommendedModel | null>

export const getModelsData = (models: RecommendedModel[]): ModelsDataType => {
  return {
    [Model.CF_PAGE_LEVEL]: getModel(models, Model.CF_PAGE_LEVEL),
    [Model.CF_PRODUCT_CATEGORY_LEVEL]: getModel(models, Model.CF_PRODUCT_CATEGORY_LEVEL),
    [Model.MIXED_ADVICE]: getModel(models, Model.MIXED_ADVICE),
    [Model.RECENT_CATEGORY]: getModel(models, Model.RECENT_CATEGORY),
    [Model.VECTOR_RECOMMENDATION]: getModel(models, Model.VECTOR_RECOMMENDATION),
  }
}
